var booleanStatus = function (status) {
    return {
        status: status,
    };
};
/**
 * Datapoint configurations.
 */
export default {
    AutomaticRepliesDeclinedEventsCountInfo: {
        datapoint: {
            name: 'AutomaticRepliesDeclinedEventsCountInfo',
            customData: function (count) {
                return {
                    count: count,
                };
            },
        },
    },
    AutomaticRepliesOnOffStatus: {
        datapoint: {
            name: 'AutomaticRepliesOnOffStatus',
            customData: booleanStatus,
        },
    },
    AutomaticRepliesTimePeriodEnabled: {
        datapoint: {
            name: 'AutomaticRepliesTimePeriodEnabled',
            customData: booleanStatus,
        },
    },
    AutomaticRepliesBlockCalendarEnabled: {
        datapoint: {
            name: 'AutomaticRepliesBlockCalendarEnabled',
            customData: booleanStatus,
        },
    },
    AutomaticRepliesDeclineNewEnabled: {
        datapoint: {
            name: 'AutomaticRepliesDeclineNewEnabled',
            customData: booleanStatus,
        },
    },
    AutomaticRepliesDeclineExistingEnabled: {
        datapoint: {
            name: 'AutomaticRepliesDeclineExistingEnabled',
            customData: booleanStatus,
        },
    },
};
//# sourceMappingURL=datapoints.js.map